const SetUser = (token) => ({
    type: 'auth/setUser'
    ,payload: token
});

const SetTokenizeUser = (user) => ({
    type: 'auth/setTokenizeUser'
    ,payload: user
});

const SetLookingUser = (loadingState) => ({
    type: 'auth/setLookingUser'
    ,payload: loadingState
});

const setUserNotif = (notif) => ({
    type: 'auth/setUserNotif'
    ,payload: notif
});

const SetInitiative = (initiative) => ({
    type: 'initiative/SetInitiative'
    ,payload: initiative
});

const SetInitiativeAccess = (access) => ({
    type: 'initiative/SetInitiativeAccess'
    ,payload: access
});

export {SetUser, SetTokenizeUser, SetLookingUser, SetInitiative, SetInitiativeAccess, setUserNotif};